// @flow

import React from 'react';

import { LazyLoadComponent } from '@zapier/common-components';
import { PaymentMethodsSectionSkeleton } from '@zapier/payment';

const LazyLoadPaymentApp = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'app-payment-App' */ 'app/payment/components/App'
    ),
  renderLoader: () => <PaymentMethodsSectionSkeleton />,
});

export default LazyLoadPaymentApp;
